export const BUILDER_MODELS = {
  ACCOUNT: 'account',
  CATEGORY_NAVIGATION: 'category-navigation',
  ACCOUNT_NAVIGATION: 'account-navigation',
  CATEGORY_PAGE: 'category-page',
  COLLECTION_PAGE: 'collection-page',
  LANDING_PAGE: 'landing-page',
  FOOTER: 'footer',
  HDYH: 'hdyh',
  HEADER: 'header',
  MOBILE_APP_HEADER: 'mobile-app-header',
  SALE_PAGE: 'sale-page',
  OUTLET: 'outlet',
  PAGE: 'page',
  PDP_STORYTELLING: 'pdp-storytelling',
  POINTS_FOR_ACTION_UI: 'points-for-actions-ui',
  PRIVATE_CONFIG: 'private-config',
  QUIZ_PAGE: 'quiz-page',
  QUIZ_CONFIG: 'quiz-config',
  SYMBOL: 'symbol',
  VIDEO: 'video',
};
